/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentDiscount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TreatmentDiscount({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info/TreatmentDiscount"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let setupTreatmentDiscountsValueData = fromData.useDataFormat({ viewPath,
context: 'setup',
path: 'treatment_discounts',
format: fromFormat.numberMoney,
})
  return (<React.Fragment
>
<div
  data-testid="TreatmentDiscount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Treatment discount applied"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="setup.treatment_discounts"
 format="/Data/format.js numberMoney"
 text={setupTreatmentDiscountsValueData}
/>
</div>
{children}
</React.Fragment>)
}